/***************************
 * 处理弹框信息
 ***************************/
import EToast from '@/components/Toast/create.js'

export const toast = ({ type = 'txt', txt, onTimeout, time, mask }) => {
  EToast({
    zIndex:10000,
    txt,
    type,
    time,
    mask,
    onTimeout
  }).show()
}

export default {
  toast,
}
